// Enum scalars from the bootstrap query — inlined rather than imported from
// __generated__/ to keep this file Relay-free.
type WorkspaceType = 'GLOBAL_EXPERIENCE' | 'PRODUCT';
type GoalScoringMode = 'OKR' | 'SIMPLE';
type AccessControlCapability = 'ACCESS' | 'ADMINISTER' | 'CREATE';
type CapabilityContainer = 'FOCUS_AREAS_APP' | 'GOALS_APP' | 'JIRA_ALIGN_APP' | 'PROJECTS_APP';

/**
 * Wire shape of the bootstrap payload the Volt controller inlines onto the
 * document. All fields optional + readonly: optional for server↔client deploy
 * skew tolerance (each side can ship contract changes independently), readonly
 * to mirror Relay's mutation discipline. Source of truth for the shape is the
 * server query at `controllers/bootstrap/projectsBootstrapQuery.ts`.
 */
export interface BootstrapVoltWorkspace {
	readonly id?: string;
	readonly uuid?: string;
	readonly cloudId?: string;
	readonly type?: WorkspaceType;
	readonly name?: string;
	readonly keyPrefix?: string;
	readonly timezone?: string;
	readonly goalScoringMode?: GoalScoringMode;
	readonly activationId?: string | null;
	readonly userCapabilities?: {
		readonly capabilities?: ReadonlyArray<{
			readonly capability?: AccessControlCapability | null;
			readonly capabilityContainer?: CapabilityContainer | null;
		} | null>;
	} | null;
}

export interface BootstrapVoltCollabContext {
	readonly cloudIds?: ReadonlyArray<string>;
	readonly isMultiSite?: boolean;
	readonly hasMultipleUnits?: boolean;
}

export interface BootstrapVoltPayload {
	readonly orgId?: string;
	readonly cloudIds?: ReadonlyArray<string>;
	readonly collabContext?: BootstrapVoltCollabContext | null;
	readonly userIsOrgAdmin?: boolean;
	readonly workspaces?: ReadonlyArray<BootstrapVoltWorkspace | null>;
}

declare global {
	// eslint-disable-next-line no-var -- required for ambient globalThis declarations
	var __TOWNSQUARE_BOOTSTRAP__: BootstrapVoltPayload | undefined;
}

/**
 * Returns the inlined TSQ bootstrap payload, or `undefined` when the server
 * did not inject one. Presence/absence IS the picker's signal — there is no
 * client-side feature gate.
 */
export function readBootstrapVoltPayload(): BootstrapVoltPayload | undefined {
	return globalThis.__TOWNSQUARE_BOOTSTRAP__;
}
